import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
import { ActiveCustomerMobEmptyStateStack } from "./indexMobEmptyState";
import { ActiveCustomerCardBuilder } from "../dashboard/utils";
export const ActiveCustomerMobStack = async (mockDATA) => {
    const DS = {
        activeCustomerMobRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: SizeTypeTokens.XXXL,
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XXXL,
            },
            widgetItems: [
                { id: 'activeCustomerMobT1', type: WIDGET.TEXT },
                { id: 'activeCustomerMobT2', type: WIDGET.TEXT },
                { id: 'activeCustomerMobRootSpace0', type: WIDGET.SPACE },
                mockDATA.length > 0 ? { id: 'activeCustomerMobRootSearchInput', type: WIDGET.INPUT } : {},
                mockDATA.length > 0 ? { id: 'activeCustomerMobRootSpace3', type: WIDGET.SPACE } : {},
                mockDATA.length > 0 ? { id: 'activeCustomerMobCardStack', type: WIDGET.STACK } : {},
                mockDATA.length === 0 ? { id: 'activeCustomerMobEmptyStateStack', type: WIDGET.STACK } : {}
            ]
        },
        activeCustomerMobCardStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: ActiveCustomerCardBuilder(mockDATA).WIDGET_STORE,
        },
        ...await ActiveCustomerMobEmptyStateStack(),
        ...ActiveCustomerCardBuilder(mockDATA).DATA_STORE,
        activeCustomerMobRootSearchInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            title: 'Search Customer',
            placeholder: 'Search by name or mobile',
            keyboardType: KeyboardTypeToken.default,
            isFocus: false,
            action: {
                type: ACTION.ON_SEARCH_AC,
                routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                payload: {
                    value: '',
                    widgetId: 'activeCustomerMobRootSearchInput',
                },
            },
        },
        activeCustomerMobT1: {
            label: `Customers`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        activeCustomerMobT2: {
            label: `Track your active customers`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 20,
        },
        activeCustomerMobRootDivider0: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        activeCustomerMobRootSpace0: {
            size: SizeTypeTokens.XL
        },
        activeCustomerMobRootSpace1: {
            size: SizeTypeTokens.XL
        },
        activeCustomerMobRootSpace2: {
            size: SizeTypeTokens.XL
        },
        activeCustomerMobRootSpace3: {
            size: SizeTypeTokens.XL
        },
    };
    return DS;
};
